import {hexToRgb} from './hexToRgb.js';
import {rgbaToRgb} from './rgbaToRgb.js';
import {extractColorFromGradient} from './extractColorFromGradient.js';

/**
 * Determines if a color is light or dark based on relative perceived luminance
 * Check out [the W3C guidelines](https://www.w3.org/TR/AERT/#color-contrast).
 * @param {string} color The value of the color to test.
 * @return {boolean} Whether the color is light.
 */
export default function isColorLight(color, defaultLightLumaThreshold = 170) {
  if (!color || typeof color !== 'string') {
    console.error('Color must be a non-empty string');
    return false;
  }
  const redLumaCoefficient = 299;
  const greenLumaCoefficient = 587;
  const blueLumaCoefficient = 114;
  const lightLumaThreshold = defaultLightLumaThreshold;

  const calculateBrightness = ([r, g, b]) =>
    (r * redLumaCoefficient + g * greenLumaCoefficient + b * blueLumaCoefficient) / 1000;

  const formatHandlers = {
    '^#': hexToRgb,
    '^rgba?\\(': rgbaToRgb,
    '^linear-gradient': extractColorFromGradient
  };

  const formatKey = Object.keys(formatHandlers).find(pattern =>
    new RegExp(pattern, 'i').test(color)
  );

  if (!formatKey) {
    console.error('Unsupported color format');
    return false;
  }

  try {
    const rgb = formatHandlers[formatKey](color);
    if (!rgb.length) return false;
    return calculateBrightness(rgb) > lightLumaThreshold;
  } catch (e) {
    console.warn(e.message);
    return false;
  }
}
